import React, { useState } from "react";
import "./confirm-booking-page.css";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentMode from "../../components/PaymentMode";
import { updateBookingConfirmationInfo } from "../../features/calendarWidgetSlice";
import NewLoader from "../../components/reusable/NewLoader";

const ConfirmBookingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const { fullName, phoneNumber, leadId } = useSelector(
    (state) => state.userDetails
  );
  const { patientFirstName, patientLastName } = useSelector(
    (state) => state.patientRegister
  );

  // console.log(`${patientFirstName} ${patientLastName}`);
  // console.log(fullName);
  const { selectedDate } = useSelector((state) => state.calendarWidget);
  const { selectedTimeSlot, selectedTimeSlotID } = useSelector(
    (state) => state.timeSlotWidget
  );
  const { consultationMode, paymentMode } = useSelector(
    (state) => state.calendarWidget
  );
  const { servicefor } = useSelector((state) => state.calendarWidget);
  // console.log(`service for : ${servicefor}`);
  // console.log(paymentMode);

  const handleComplete = () => {
    setShowLoader(true);
    bookAppointment()
      .then((result) => {
        if (result) {
          // Handle success
          let nextNav = `/booking-successful`;
          navigate(nextNav);
        } else {
          // Handle failure
          toast.error("Something Went wrong, appointment not booked!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {
        // Handle error
        console.error(`Error booking appointment: ${error}`);
      });
  };

  /**
   * final API call that books the appointment
   * PUT Request
   * @function bookAppointment()
   * @returns promise
   * @param data
   */
  const bookAppointment = () => {
    let data = JSON.stringify({
      lead_id: leadId,
      consultation_type_id: consultationMode,
      availability: "booked",
      caller_name: fullName,
      patient_name:
        servicefor === "yourself"
          ? fullName
          : `${patientFirstName} ${patientLastName}`,
      appointment_type: "individual_appointment",
      payment_mode: paymentMode
        ? paymentMode
        : alert("please select a payment mode!"),
    });

    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_API_ENDPOINT}/book_appointment/${Number(
          selectedTimeSlotID
        )}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_BOOK_APPOINTMENT_API_TOKEN}`,
        },
        data: data,
      })
        .then((response) => {
          // console.log("Success Response is ------------", response);
          if (
            response?.data?.result[0]?.error ===
            "Lead has confirmed or ongoing appointments."
          ) {
            toast.error(response?.data?.result[0]?.message);
            reject(false);
            setShowLoader(false);
          } else if (response?.data?.result[0]?.error === "Booking Conflict") {
            toast.error(response?.data?.result[0]?.message);
            reject(false);
            setShowLoader(false);
          } else if (response?.data?.result[0]?.error) {
            // console.log(response?.data?.result[0]?.error);
            toast.error("appointment not booked");
            reject(false);
            setShowLoader(false);
          } else {
            const bookingInfo = response?.data?.result[0]?.["slot.booking"];
            dispatch(updateBookingConfirmationInfo({ ...bookingInfo }));
            resolve(true); // Resolve the promise for success
            setShowLoader(false);
          }
        })
        .catch((err) => {
          console.log("Error is --------------", err);
          setShowLoader(false);
          // toast.error(error);
          reject(false); // Reject the promise for error
        });
    });
  };

  return (
    <div className="confirm-booking-page">
      <div className="confirm-booking-page__summary">
        <h1>Booking details</h1>
        <h2>Booking for:</h2>
        <span className="user__name">
          {servicefor === "yourself"
            ? fullName
            : `${fullName} on behalf of ${patientFirstName}`}
        </span>
        <br />
        <span className="user__Phone-no">{`${phoneNumber}`}</span>
        <Divider />

        <h2>Consultation Mode</h2>
        <div className="appointment__field-data-wrapper">
          <span>
            {consultationMode === 1
              ? "In-Person consultation"
              : consultationMode === 2
              ? "Online consultation"
              : "Please select a consultation type"}
          </span>
          <Link to={"/select-consultation-type"}>
            <Button variant="outlined">Select mode</Button>
          </Link>
        </div>
        {/* <ConsultationTypeComponent /> */}
        <Divider />

        <h2>Date</h2>
        <div className="appointment__field-data-wrapper">
          <span>{`${selectedDate}`}</span>
          <Link to="/calendar">
            <Button variant="outlined">Select Date</Button>
          </Link>
        </div>
        <Divider />

        <h2>Time</h2>
        <div className="appointment__field-data-wrapper">
          <span>
            {selectedTimeSlot ? selectedTimeSlot : "please select time slot!"}
          </span>
          <Link to={"/select-slot"}>
            <Button variant="outlined">Select Time slot</Button>
          </Link>
        </div>
        <Divider />

        <h2>Payment mode</h2>
        <div className="appointment__field-data-wrapper">
          <PaymentMode />
        </div>
        <Divider />

        <Divider />
        <div>
          <Divider />
          <h2>Map Link</h2>
          <iframe
            src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.0266357912915!2d77.58442637598827!3d12.90600878740338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1513b91d8bb9%3A0x6b0b777280a26610!2sCadabams%20Hospitals!5e0!3m2!1sen!2sin!4v1684848897180!5m2!1sen!2sin`}
            height="450"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Map"
          ></iframe>
        </div>
      </div>

      <div className="navigation-btn__group">
        <Button
          className="proceed-to-payment__btn"
          endIcon={!showLoader ? <NavigateNextIcon /> : <NewLoader />}
          // onClick={bookAppointment}
          onClick={handleComplete}
          disabled={selectedTimeSlot === "" ? true : false}
        >
          Complete booking process
        </Button>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ConfirmBookingPage;
